import { cva, VariantProps } from 'class-variance-authority'
import { HTMLAttributes, memo, ReactNode } from 'react'
import { cn } from '~utils/cn'

export type LabelColor =
  | 'gray'
  | 'primary'
  | 'library-leather'
  | 'coral-orange'
  | 'cotton-muslin'
  | 'brochantite-green'
  | 'oil-blue'
  | 'down-pour'
  | 'architecture-blue'
  | 'black-opacity'
  // TODO. 리브랜딩 작업 완료 후 아래 레거시 컬러들 제거
  | 'red'
  | 'orange'
  | 'green'
  | 'pink'
  | 'violet'
  | 'lime'
  | 'grape'
  | 'cyan'
  | 'indigo'
type LabelSize = 'large' | 'small'

interface LabelProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof labelStyle> {
  children: ReactNode
  color?: LabelColor
  size?: LabelSize
}

const labelStyle = cva(['w-fit rounded-2xl inline-block shrink-0'], {
  variants: {
    color: {
      gray: 'bg-gray-400 text-white',
      primary: 'bg-primary-600 text-white',
      'library-leather': 'bg-tag-library-leather text-white',
      'coral-orange': 'bg-tag-coral-orange text-white',
      'cotton-muslin': 'bg-tag-cotton-muslin text-gray-900',
      'brochantite-green': 'bg-tag-brochantite-green text-white',
      'oil-blue': 'bg-tag-oil-blue text-white',
      'down-pour': 'bg-tag-down-pour text-white',
      'architecture-blue': 'bg-tag-architecture-blue text-white',
      'black-opacity': 'bg-black/60 text-white',
      // TODO. 리브랜딩 작업 완료 후 아래 레거시 컬러들 제거
      red: 'bg-red-50 text-red-600',
      orange: 'bg-orange-50 text-orange-600',
      green: 'bg-green-50 text-green-600',
      pink: 'bg-pink-50 text-pink-600',
      violet: 'bg-violet-50 text-violet-600',
      lime: 'bg-lime-50 text-lime-800',
      grape: 'bg-grape-50 text-grape-700',
      cyan: 'bg-cyan-50 text-cyan-600',
      indigo: 'bg-indigo-50 text-indigo-600',
    },
    size: {
      small: 'text-label-3 px-2 py-[2px]',
      large: 'text-label-2 px-[10px] py-1',
    },
  },
  defaultVariants: {
    color: 'primary',
    size: 'large',
  },
})

/**
 * @version v1.0.1
 * @author Danny
 */
const Label = ({ children, color, size, ...props }: Readonly<LabelProps>) => {
  const { className } = props

  return (
    <div {...props} className={cn(labelStyle({ color, size }), className)}>
      {children}
    </div>
  )
}

export default memo(Label)
